"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.projectIdRestorationMapper = void 0;
const projects_1 = require("../projects");
const WILDFLOWERS = 4826;
exports.projectIdRestorationMapper = {
    [WILDFLOWERS]: projects_1.RestorationProjectType.Wildflowers,
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGFiaXRhdC1yZXN0b3JhdGlvbi1wcm9qZWN0cy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uLy4uL3NyYy9oYWJpdGF0LXJlc3RvcmF0aW9uL2hhYml0YXQtcmVzdG9yYXRpb24tcHJvamVjdHMudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7O0FBQUEsMENBQXFEO0FBRXJELE1BQU0sV0FBVyxHQUFHLElBQUksQ0FBQztBQUVaLFFBQUEsMEJBQTBCLEdBR25DO0lBQ0YsQ0FBQyxXQUFXLENBQUMsRUFBRSxpQ0FBc0IsQ0FBQyxXQUFXO0NBQ2xELENBQUMifQ==